import { ZONATARGET } from "../../actions/portal/";

export default function(state = [], action) {
  switch (action.type) {
    case ZONATARGET:
      return [action.payload, ...state];
    default:
  }
  return state;
}
